<template>
  <!--  style="top: 60px; height: calc(100vh - 60px)" -->
  <el-drawer
    v-model="showDrawer"
    :modal="true"
    :show-close="false"
    close-on-click-modal
    size="40%"
    class="message-center"
  >
    <template #header>
      <div style="display: flex; align-items: center">
        <div style="flex: 1">
          <el-badge
            v-if="isNoRead > 0"
            :value="isNoRead"
            style="margin-right: 20px"
          >
            <el-button
              link
              plain
              @click="changeReadFlag(0)"
              :type="activeTitle == 0 ? 'primary' : ''"
              >未读</el-button
            >
          </el-badge>
          <el-button
            v-else
            link
            plain
            @click="changeReadFlag(0)"
            :type="activeTitle == 0 ? 'primary' : ''"
            >未读</el-button
          >
          <el-button
            link
            plain
            @click="changeReadFlag(null)"
            :type="activeTitle !== 0 ? 'primary' : ''"
            >全部</el-button
          >
        </div>
        <div style="display: flex">
          <el-button link plain type="primary" @click="setReadAll({}, 'All')"
            >全部设置已读</el-button
          >
        </div>
      </div>
    </template>
    <template #default>
      <div style="overflow: auto; height: calc(100vh - 200px)">
        <ul
          v-infinite-scroll="loadScroll"
          :infinite-scroll-disabled="infiniteDisabled"
          :infinite-scroll-delay="600"
          :infinite-scroll-distance="50"
          :infinite-scroll-immediate="false"
        >
          <li
            class="jsc-info_body"
            v-for="(item, index) in messageDrawerList"
            :key="item.messageId"
            @mouseenter="setItemRead(index, item)"
            @mouseleave="setItemReadNull"
          >
            <span class="dot" v-if="item.readFlag == 0"></span>
            <p>
              {{
                item.content?.indexOf("点击跳转") !== -1
                  ? item.content?.replace(new RegExp("点击跳转", "g"), "")
                  : item.content
              }}
              <el-link
                type="primary"
                :underline="false"
                style="margin-left: -5px; margin-top: -3px"
                v-if="item.content?.indexOf('点击跳转') !== -1"
                @click.stop="toMenu(item)"
                >点击跳转</el-link
              >
            </p>
            <span v-if="item.readFlag == 1 || index !== itemRed">{{
              item.updateTime
            }}</span>
            <span v-if="item.readFlag == 0 && index == itemRed"
              ><el-button
                link
                type="primary"
                @click.stop="setReadAll(item, 'item')"
                >设为已读</el-button
              ></span
            >
          </li>
        </ul>
        <p v-if="loading && messageDrawerList.length > 0" class="loading">
          加载中...
        </p>
        <div v-if="messageDrawerList.length == 0" class="empty-box">
          <img src="@/assets/images/empty.png" alt="空" class="empty-img" />
          <p>空空如也~</p>
        </div>
      </div>
    </template>
  </el-drawer>
</template>
<script lang="ts" setup>
import { messageList, setReadFlag } from "@/api/messageCenterApi/index.ts";
import dayjs from "dayjs";
import { useAppStore, useUserStore } from "@/stores"; // 内部模块
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { messageType, query } from "@/utils/messageToPath";
const router = useRouter();
const app = useAppStore();
const user = useUserStore();
console.log(app.$state);
const readFlag = ref(0);
const showDrawer = ref(false);
const pageIndex = ref(1);
const itemRed = ref<any>(null); // 单个消息设置已读
const messageDrawerList = ref<any>([]);
const loading = ref(false);
const noMore = ref(false);
const messageTotal = ref(0);
const infiniteDisabled = computed(() => loading.value || noMore.value);
// 未读消息条数
const isNoRead = computed(() => app.isNoRead);
// 将消息全部设置为已读
async function setReadAll(obj: any = {}, type: string, NoTips = "") {
  try {
    return new Promise(async (resolve, reject) => {
      // 已读标记 0未读  1已读
      const params: any = {
        readFlag: 1,
        target: 7,
      };
      if (type == "item") {
        params.messageIds = [obj?.messageId];
      }
      const res: any = await setReadFlag(params);
      if (res?.code == 200) {
        if (!NoTips) {
          ElMessage.success("设置成功");
        }
        if (type == "item" && activeTitle.value == 0) {
          // 处于未读时  设置单个已读
          messageDrawerList.value = messageDrawerList.value.filter(
            (item) => item.messageId !== obj?.messageId,
          );
        } else if (type == "item" && activeTitle.value !== 0) {
          // 处于全部时  设置单个已读
          messageDrawerList.value = messageDrawerList.value.map((item) => {
            if (item.messageId == obj?.messageId) {
              return {
                ...item,
                readFlag: 1,
              };
            } else {
              return item;
            }
          });
        } else {
          // 当处于未读时 设置为空数组  当处于全部时 设置为已读
          messageDrawerList.value =
            activeTitle.value == 0
              ? []
              : messageDrawerList.value.map((item) => {
                  return {
                    ...item,
                    readFlag: 1,
                  };
                });
        }
        app.getQueryMsgCount();
        resolve(true);
      }
    });
  } catch (error) {
    console.log(error);
  }
}
const activeTitle = ref(0);
const changeReadFlag = (val: any) => {
  activeTitle.value = val;
  readFlag.value = val;
  pageIndex.value = 1;
  messageDrawerList.value = [];
  loadScroll();
};
const loadScroll = async () => {
  try {
    // 如果总数和数组长度相同则停止请求
    if (
      messageTotal.value == messageDrawerList.value.length &&
      messageTotal.value > 0
    )
      return;
    loading.value = true;
    const params: any = {
      target: 7,
      pageIndex: pageIndex.value++,
      pageSize: 15,
      receiver: user.userInfo.userId,
    };
    if (readFlag.value == 0) {
      params.readFlag = readFlag.value;
    }
    const res: any = await messageList(params);

    loading.value = false;
    if (res?.code == 200) {
      let list: any = res?.data?.list?.map((item: any) => {
        return {
          ...item,
          times: item.updateTime,
          updateTime: dayjs(item.updateTime)?.format("MM/DD HH:mm:ss"),
        };
      });
      messageDrawerList.value = removeDuplicatesById(
        messageDrawerList.value.concat(list),
      ).sort((a: any, b: any) => {
        return b.times - a.times;
      });
      messageTotal.value = res?.data?.total;
    }
  } catch (error) {
    loading.value = false;
  }
};
// 数组去重
function removeDuplicatesById(arr) {
  const seenIds: Set<number> = new Set();
  const result: { id: number; name: string }[] = [];
  for (const item of arr) {
    if (!seenIds.has(item.messageId)) {
      seenIds.add(item.messageId);
      result.push(item);
    }
  }

  return result;
}
function setItemRead(index, item: any) {
  if (item.value == 1) return;
  itemRed.value = index;
}
function setItemReadNull() {
  itemRed.value = null;
}

const openMessage = () => {
  showDrawer.value = true;
  pageIndex.value = 1;
  loadScroll();
  app.getQueryMsgCount();
};
const toMenu = (row) => {
  console.log(messageType[row.businessType]);
  setReadAll(row, "item", "NoTips");
  router.push({
    path: messageType[row.businessType],
    query: {
      type: query[row.businessType],
    },
  });
  showDrawer.value = false;
};

defineExpose({
  openMessage,
});
</script>
<style lang="scss" scoped>
.message-center {
  color: #303133;
  overflow: hidden;
  :deep(.el-drawer__header) {
    padding: 20px 16px 6px 16px;
    border-bottom: none;
  }
  .jsc-info_body {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #303132;
    margin-bottom: 10px;
    cursor: pointer;
    position: relative;
    .dot {
      position: absolute;
      top: 10px;
      display: inline-block;
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #ff0000;
    }
    p {
      width: 80%;
      line-height: 30px;
      display: -webkit-box; /* Required for -webkit-line-clamp */
      -webkit-box-orient: vertical; /* Required for -webkit-line-clamp */
      -webkit-line-clamp: 3; /* Number of lines to show */
      overflow: hidden; /* Ensures content that is not displayed does not take up space */
      text-overflow: ellipsis; /* Adds ellipsis (...) */
      text-indent: 5px;
      .el-link {
        line-height: 30px;
      }
    }
    span {
      display: inline-block;
      height: 100%;
      width: 20%;
      line-height: 50px;
      text-align: right;
      width: 30%;
      color: #999999;
    }
  }
}
.empty-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  font-size: 14px;
  color: #606266;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  img {
    width: 130px;
    height: 132px;
    margin-bottom: 10px;
  }
}
.active-btn {
  color: #477fff !important;
}
</style>
